import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import axios from "axios";
import {API_URL} from "../config";

const LegalPopup = () => {
    const [open, setOpen] = useState(false);
    const getUserIp = async () => {
        try {
            const response = await fetch("https://api.ipify.org?format=json");
            const data = await response.json();
            return data.ip;
        } catch (err) {
            console.error("IP alınamadı:", err);
            return "unknown";
        }
    };
    useEffect(() => {
        const storedData = localStorage.getItem("legal-popup");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const now = new Date().getTime();
            if (now - parsed.time > 36 * 60 * 60 * 1000) { // 36 saat geçtiyse tekrar göster
                setOpen(true);
            }
        } else {
            setOpen(true); // hiç onay verilmemişse göster
        }
    }, []);

    const handleAccept = async (dontShowAgain) => {
        if (dontShowAgain) {
            localStorage.setItem("legal-popup", JSON.stringify({time: new Date().getTime()}));

            const ip = await getUserIp();
            const now = new Date().toISOString(); // ISO formatlı tarih-saat
            const version = "v1.0"; // Sözleşme versiyonu (elle ya da config'ten çekebilirsin)

            const payload = {
                ip_address: ip,
                timestamp: now,
                version: version
            };

            try {
                const response = await axios.post(`${API_URL}/auth/users/user-check/`, payload);
                console.log("Onay bilgisi gönderildi:", response.data);
            } catch (err) {
                console.error("Onay bilgisi gönderilemedi:", err);
            }

        }
        setOpen(false);
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Yasal Uyarı</DialogTitle>
            <DialogContent>
                <p>
                    Kullanıcılar, siteye giriş yaparak tüm koşulları ve kullanıcı sözleşmesini kabul etmiş sayılır ve bu platformu kullanımları sonucunda ortaya çıkabilecek olumsuzluklardan (sağlık hizmeti sunucusunun yetkin olmaması, malpraktis, hizmet alamama, hizmette eksiklik/gecikme/iptal/mağduriyet ve diğer tüm olumsuzluklar) dolayı oluşabilecek bir zarar durumunda platformun sorumluluğu olmadığını kabul etmiş olurlar.
                </p>
                <p><strong>Sözleşme şartlarını okudum, anladım, onaylıyorum.</strong></p>
                <p><a href={'https://acilcocukdoktoru.com/public/kullanici_aydinlatma_metni.pdf'}>Aydınlatma Metni</a>
                </p>
                {' '}
                <a href="https://acilcocukdoktoru.com/public/kullanici_sozlesmesi.pdf" target="_blank"
                   rel="noopener noreferrer">
                    Kullanıcı Sözleşmesi
                </a>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleAccept(true)} variant="contained" color="primary">
                    Onaylıyorum ve bu uyarıyı bir daha gösterme
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LegalPopup;